import PropTypes from 'prop-types';
import truncate from 'lodash/truncate';

const Text = (props) => truncate(props.value, { length: props.maxLength, separator: ' ' });

Text.propTypes = {
  value: PropTypes.string,
  maxLength: PropTypes.number,
};

export default Text;
